import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { getConversationsQueryKey } from '@web/conversations/utils/getQueryKey';
import { useSocketConnectionContext } from '@web/components/SocketConnectionProvider/SocketConnectionProvider';
import { IncomingCommand } from '@web/components/SocketConnectionProvider/types/command';

export const useConversationServerReconnectionSync = () => {
  const queryClient = useQueryClient();
  const { subscribe } = useSocketConnectionContext();

  useEffect(
    () =>
      subscribe(IncomingCommand.SOCKET_RECONNECT, () => {
        const key = getConversationsQueryKey();

        void queryClient.refetchQueries(key, {
          exact: false,
          type: 'active',
        });

        queryClient.removeQueries(key, {
          exact: false,
          type: 'inactive',
        });
      }),
    [queryClient, subscribe]
  );
};
